import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;

import { css, memoizeStyle } from "../../../../lib/theming/Emotion";
var styles = {
  root: function root() {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      width: 100%;\n    "])));
  },
  content: function content() {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      display: flex;\n      width: 100%;\n      align-items: center;\n    "])));
  },
  error: function error(t) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      color: ", ";\n    "])), t.fileUploaderBorderColorError);
  },
  name: function name() {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      flex: 1 1 100%;\n      overflow: hidden;\n    "])));
  },
  size: function size() {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      margin-left: 28px;\n      flex: 1 0 auto;\n    "])));
  },
  icon: function icon(t) {
    return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n      width: 16px;\n      flex: 1 0 auto;\n      cursor: pointer;\n      font-size: ", ";\n      text-align: right;\n      outline: none;\n    "])), t.fileUploaderIconSize);
  },
  iconSmall: function iconSmall() {
    return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n      margin-left: 4px;\n    "])));
  },
  iconMedium: function iconMedium() {
    return css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n      margin-left: 6px;\n      width: 18px;\n    "])));
  },
  iconLarge: function iconLarge() {
    return css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n      margin-left: 6px;\n      width: 20px;\n    "])));
  },
  iconMultiple: function iconMultiple() {
    return css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["\n      position: static;\n    "])));
  },
  contentSmall: function contentSmall(t) {
    return css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteralLoose(["\n      font-size: ", ";\n    "])), t.fileUploaderFontSizeSmall);
  },
  contentMedium: function contentMedium(t) {
    return css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteralLoose(["\n      font-size: ", ";\n    "])), t.fileUploaderFontSizeMedium);
  },
  contentLarge: function contentLarge(t) {
    return css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteralLoose(["\n      font-size: ", ";\n    "])), t.fileUploaderFontSizeLarge);
  },
  deleteIcon: function deleteIcon(t) {
    return css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteralLoose(["\n      color: ", ";\n      &:hover {\n        color: ", ";\n      }\n    "])), t.fileUploaderIconColor, t.fileUploaderIconHoverColor);
  },
  focusedIcon: function focusedIcon(t) {
    return css(_templateObject15 || (_templateObject15 = _taggedTemplateLiteralLoose(["\n      outline: 1px solid ", ";\n    "])), t.borderColorFocus);
  }
};
export var jsStyles = memoizeStyle(styles);